import { FC } from "react";
import { cn } from "../../../utils";
import { ChatbotMessage, chatbotMessageState } from "@ac-expo/api-types";
import Markdown from "react-markdown";

type ChatMessagesProps = {
  messages: ChatbotMessage[];
};
export const ChatMessages: FC<ChatMessagesProps> = ({ messages }) => {
  return messages.map((msg) =>
    msg.from === "bot" ? (
      <BotMessage key={msg.id} content={msg.content} />
    ) : (
      <UserMessage
        key={msg.id}
        content={msg.content}
        isSending={msg.state === chatbotMessageState.sending}
      />
    )
  );
};

const BotMessage: FC<{ content: string }> = ({ content }) => {
  return (
    <div className="flex justify-start">
      <div className="max-w-xs break-words rounded-lg rounded-tl-none border bg-white px-4 py-2 text-sm font-normal text-[#1D1D1B]">
        <Markdown>{content}</Markdown>
      </div>
    </div>
  );
};

const UserMessage: FC<{ content: string; isSending: boolean }> = ({
  content,
  isSending,
}) => {
  return (
    <div className="flex justify-end">
      <div
        className={cn(
          "max-w-xs break-all rounded-lg rounded-tr-none bg-[#0A4979] px-4 py-2 text-sm font-normal text-white",
          {
            "bg-opacity-70": isSending,
          }
        )}
      >
        {content}
      </div>
    </div>
  );
};
